import { TablePage } from 'src/views/abi/component/abiquery'
import pathMap from 'src/paths/pathMap'
import React from 'react'

class AbiQueryRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.ABI_QUERY_LIST_VIEW,
        component: TablePage
      }
    ]
  }
}

export default AbiQueryRoute
